
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxClermontFerrand = () => {
  return (
    <CityMetauxPage
      cityName="Clermont-Ferrand"
      departmentName="Puy-de-Dôme"
      departmentCode="63"
      region="Auvergne-Rhône-Alpes"
      description="Capitale auvergnate et centre industriel majeur, Clermont-Ferrand bénéficie de notre expertise dans le rachat de métaux issus de l'industrie automobile, pneumatique et de la métallurgie locale."
      specialities={[
        "Métaux de l'industrie automobile",
        "Ferraille pneumatique et caoutchouc",
        "Métaux de précision industrielle",
        "Équipements de recherche et développement"
      ]}
      nearbyAreas={[
        "Riom", "Thiers", "Issoire", "Cournon-d'Auvergne", "Chamalières", "Beaumont"
      ]}
      heroImage="https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=1280&q=80"
    />
  );
};

export default AchatMetauxClermontFerrand;
